'use client';
import React, { useState } from 'react';
import Link from 'next/link';
import { usePathname, useRouter } from 'next/navigation';
import AppLogo from '@/components/ui/AppLogo';
import { Menu, X } from 'lucide-react';

const NAV_ITEMS = [
  { label: 'Home',       href: '/dashboard' },
  { label: 'Live Map',   href: '/map' },
  { label: 'Assessment', href: '/assessment-personal-information-confirmation' },
  { label: 'Resources',  href: '/resources' },
];

export default function Topbar() {
  const pathname  = usePathname();
  const router    = useRouter();
  const [open, setOpen] = useState(false);

  return (
    <>
      <header
        className="bg-[#1a4089] text-white h-16 flex items-center px-6 lg:px-8 shadow-nav z-50 flex-shrink-0"
        style={{ position: 'sticky', top: 0 }}
      >
        {/* Logo */}
        <Link href="/dashboard" className="flex items-center gap-3 flex-shrink-0" onClick={() => setOpen(false)}>
          <AppLogo size={36} />
          <span className="font-bold text-xl tracking-tight text-white">ATLAS</span>
        </Link>

        {/* Desktop nav — centered */}
        <nav className="hidden lg:flex items-center gap-1 flex-1 justify-center">
          {NAV_ITEMS.map((item) => {
            const active = pathname === item.href;
            return (
              <Link
                key={item.href}
                href={item.href}
                className={`px-4 py-2 rounded-lg text-sm font-medium transition-all duration-150 ${
                  active ? 'bg-white/20 text-white' : 'text-blue-200 hover:text-white hover:bg-white/10'
                }`}
              >
                {item.label}
              </Link>
            );
          })}
        </nav>

        {/* Right side */}
        <div className="flex items-center gap-3 ml-auto">
          <button
            onClick={() => router.push('/hub/overview')}
            className="hidden sm:flex items-center justify-center bg-white text-[#204998] border-2 border-[#204998] font-semibold text-sm px-5 rounded-full transition-all hover:bg-[#f0f4fc] active:scale-95"
            style={{ height: '44px' }}
          >
            Clinician Hub
          </button>

          {/* Hamburger — mobile only */}
          <button
            className="lg:hidden p-2 rounded-lg hover:bg-white/10 transition-colors"
            onClick={() => setOpen((v) => !v)}
            aria-label="Toggle menu"
          >
            {open ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>
      </header>

      {/* Mobile dropdown */}
      {open && (
        <div
          className="lg:hidden bg-[#1a4089] border-t border-white/10 px-6 py-4 space-y-1 z-40 flex-shrink-0"
          style={{ position: 'sticky', top: 64 }}
        >
          {NAV_ITEMS.map((item) => {
            const active = pathname === item.href;
            return (
              <Link
                key={item.href}
                href={item.href}
                onClick={() => setOpen(false)}
                className={`block px-4 py-3 rounded-lg text-sm font-medium transition-all duration-150 ${
                  active ? 'bg-white/20 text-white' : 'text-blue-200 hover:text-white hover:bg-white/10'
                }`}
              >
                {item.label}
              </Link>
            );
          })}
          <button
            onClick={() => { router.push('/hub/overview'); setOpen(false); }}
            className="w-full mt-2 flex items-center justify-center bg-white text-[#204998] font-semibold text-sm px-5 py-3 rounded-full hover:bg-[#f0f4fc] transition-colors"
          >
            Clinician Hub
          </button>
        </div>
      )}
    </>
  );
}
